import { useEffect, useState } from 'react'
import { getManagedBuildingPassports } from 'services/taskService'

let cached = null
let inflight = null

export const resetManagedBuildingsCache = () => {
  cached = null
  inflight = null
}

const load = () => {
  if (cached) return Promise.resolve(cached)
  if (!inflight) {
    inflight = getManagedBuildingPassports()
      .then(res => {
        cached = (res?.data?.data || [])
          .map(row => ({ value: row.id, label: row.name || 'Unnamed Building Passport' }))
          .sort((a, b) => a.label.localeCompare(b.label))
        return cached
      })
      .catch(error => {
        inflight = null
        throw error
      })
  }
  return inflight
}

const useManagedBuildings = (enabled = true) => {
  const [state, setState] = useState(() => ({ options: cached || [], loading: enabled && !cached }))

  useEffect(() => {
    if (!enabled) return undefined
    if (cached) {
      setState({ options: cached, loading: false })
      return undefined
    }
    let live = true
    setState(prev => ({ ...prev, loading: true }))
    load()
      .then(options => { if (live) setState({ options, loading: false }) })
      .catch(() => { if (live) setState({ options: [], loading: false }) })
    return () => { live = false }
  }, [enabled])

  return state
}

export default useManagedBuildings
